import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'; // ✅ Added Navigate
import AdminLayout from './components/AdminLayout'; // ✅ Added AdminLayout
import { AuthProvider, useAuth } from './context/AuthContext'; // ✅ Added
import { BrandingProvider } from './context/BrandingContext';
import Login from './pages/Login'; // ✅ Added
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import AdminDashboard from './pages/AdminDashboard';
import Users from './pages/Users';
import Roles from './pages/Roles';
import AuditLogs from './pages/AuditLogs';
import Config from './pages/Config';
import Products from './pages/Products';
import Claims from './pages/Claims';
import Payments from './pages/Payments';
import Support from './pages/Support';
import HelpCenter from './pages/HelpCenter';
import Customers from './pages/Customers';
import CustomerDetail from './pages/CustomerDetail';
import UserForm from './pages/UserForm';
import RoleForm from './pages/RoleForm'; // ✅ Added
import UserFeedback from './pages/UserFeedback';
import Applications from './pages/Applications';
import WhatsAppChats from './pages/WhatsAppChats';
import CorePolicies from './pages/CorePolicies';
import CoreClaims from './pages/CoreClaims';
import CoreIntermediaries from './pages/CoreIntermediaries';
import CoreReinsurance from './pages/CoreReinsurance';
import CoreRegulatory from './pages/CoreRegulatory';
import RoadTrafficVerification from './pages/RoadTrafficVerification';
import CommercialFleets from './pages/CommercialFleets';


import { Toaster } from 'react-hot-toast';

export default function App() {
  return (
    <BrandingProvider>
      <Toaster position="top-right" toastOptions={{ duration: 4000 }} />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public Routes (No Auth Required) */}
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify-cover-note" element={<RoadTrafficVerification />} />
            <Route path="/verify-cover-note/:token" element={<RoadTrafficVerification />} />
            <Route path="/verify/cover-note/:token" element={<RoadTrafficVerification />} />

            {/* Protected Routes */}
            <Route element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="/users" element={<Users />} />
              <Route path="/users/new" element={<UserForm />} />
              <Route path="/users/:userId" element={<UserForm />} />
              <Route path="/roles" element={<Roles />} />
              <Route path="/roles/new" element={<RoleForm />} />
              <Route path="/roles/:roleId" element={<RoleForm />} />
              <Route path="/logs" element={<AuditLogs />} />
              <Route path="/config" element={<Config />} />
              <Route path="/products" element={<Products />} />
              <Route path="/claims" element={<Claims />} />
              <Route path="/payments" element={<Payments />} />
              <Route path="/applications" element={<Applications />} />

              {/* Enterprise Core Insurance Engine Routes */}
              <Route path="/core/policies" element={<CorePolicies />} />
              <Route path="/core/fleets" element={<CommercialFleets />} />
              <Route path="/core/claims" element={<CoreClaims />} />
              <Route path="/core/intermediaries" element={<CoreIntermediaries />} />
              <Route path="/core/reinsurance" element={<CoreReinsurance />} />
              <Route path="/core/regulatory" element={<CoreRegulatory />} />

              <Route path="/admin/support" element={<Support />} />
              <Route path="/admin/help-center" element={<HelpCenter />} />
              <Route path="/admin/customers" element={<Customers />} />
              <Route path="/admin/customers/:id" element={<CustomerDetail />} />
              <Route path="/admin/feedback" element={<UserFeedback />} /> {/* ✅ Added Feedback Route */}
              <Route path="/whatsapp-chats" element={<WhatsAppChats />} />
              {/* Catch-all: Redirect to dashboard */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </BrandingProvider>
  );
}